import { Component, OnInit, OnDestroy, Output, Input, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService, OptionsserviceService, LoansService, StorageService, OperationsService } from '../../_services/index';
import { ActivatedRoute } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-uploadpayments',
  templateUrl: './uploadpayments.component.html',
  styleUrls: ['./uploadpayments.component.css']
})
export class UploadpaymentsComponent implements OnInit {
  product_id = '';
  products = [
    {
        "LOAN_PRODUCT_ID": "29822",
        "LOAN_TITLE": "LPO Finance"
    },
    {
        "LOAN_PRODUCT_ID": "29939",
        "LOAN_TITLE": "School Now Pay Later"
    },
    {
        "LOAN_PRODUCT_ID": "29940",
        "LOAN_TITLE": "Teachers Payday Loan"
    },
    {
        "LOAN_PRODUCT_ID": "29941",
        "LOAN_TITLE": "School - Working Capital"
    },
    {
        "LOAN_PRODUCT_ID": "29942",
        "LOAN_TITLE": "Rent Now Pay Later"
    },
    {
        "LOAN_PRODUCT_ID": "29943",
        "LOAN_TITLE": "Rent - Houses"
    },
    {
        "LOAN_PRODUCT_ID": "29944",
        "LOAN_TITLE": "Merchants - Working Capital"
    },
    {
        "LOAN_PRODUCT_ID": "29945",
        "LOAN_TITLE": "Buy Now Pay Later"
    },
    {
        "LOAN_PRODUCT_ID": "29946",
        "LOAN_TITLE": "Hosiptality - Working Capital"
    },
    {
        "LOAN_PRODUCT_ID": "29947",
        "LOAN_TITLE": "Hosiptality - Customers"
    },
    {
        "LOAN_PRODUCT_ID": "29948",
        "LOAN_TITLE": "Eat - Working Capital"
    },
    {
        "LOAN_PRODUCT_ID": "29949",
        "LOAN_TITLE": "Eat - Customers"
    },
    {
        "LOAN_PRODUCT_ID": "29955",
        "LOAN_TITLE": "School - MSBM"
    },
    {
        "LOAN_PRODUCT_ID": "29961",
        "LOAN_TITLE": "Hospitality - Hygeia hmo"
    },
    {
        "LOAN_PRODUCT_ID": "29968",
        "LOAN_TITLE": "School Gap Finance"
    },
    {
        "LOAN_PRODUCT_ID": "29975",
        "LOAN_TITLE": "Light Now Pay Later"
    },
    {
        "LOAN_PRODUCT_ID": "29977",
        "LOAN_TITLE": "Cinema - BNPL"
    },
    {
        "LOAN_PRODUCT_ID": "29978",
        "LOAN_TITLE": "School Fees Gap Finance"
    },
    {
        "LOAN_PRODUCT_ID": "29983",
        "LOAN_TITLE": "Merchant Upfront Finance"
    },
    {
        "LOAN_PRODUCT_ID": "29992",
        "LOAN_TITLE": "School Improvement Finance"
    },
    {
        "LOAN_PRODUCT_ID": "29994",
        "LOAN_TITLE": "Travel"
    },
    {
        "LOAN_PRODUCT_ID": "29995",
        "LOAN_TITLE": "PharmFund"
    },
    {
        "LOAN_PRODUCT_ID": "29998",
        "LOAN_TITLE": "Social Credit"
    }
];
  send_payments_to_queue:any;
  result: any;
  attachments: any;
  currentUser: any;
  description = '';
  file_field: any;
  loading = false;
  file_type = '2';
  photoHasBeenUploaded = false;
  fileHasBeenUploaded = false;
  doc_types: any;
  DOCTYPE: any;
  @ViewChild('file') file;
  param = {
    'search_string':''
  }
  filesUploaded = [];
  public files: Set<File> = new Set();
  uploadingfile = false;
  filesSaved = false;
  due_loans:any;
  public banks:any;
  finalpay = false;
  lender:any;
  constructor(private sanitizer: DomSanitizer,
    private DataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public toastr: ToastrService,
    public productService: ProductsService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.lender = this.storageService.read<any>('platform');
  }
  fileUploadeds(event) {
  }
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  ngOnInit() {
    this.getBanks();
    this.getDueRepayments();
    // this.productService
    //   .getLoanProductsSlim(this.currentUser.token)
    //   .subscribe(companies => (this.products = companies));
  }
  getDueRepayments(){
    this.loading = true;
    this.operationsService.getBulkRepayments(this.currentUser.token,this.param)
      .subscribe(result => {
        this.loading = false;
        // this.has_data = result.has_data;
        // this.repayments = result.message;
        this.send_payments_to_queue = result.send_payments_to_queue;
      });
  }
  uploadTheFile() {

    this.loading = true;
    this.operationsService.uploadTheLoanPhoto(this.currentUser.token, this.filesUploaded)
      .subscribe(result => {
        this.loading = false;
        this.result = result;
        this.filesSaved = true;
      });
  }
  getBanks() {
    this.operationsService.getBanks(this.currentUser.token)
      .subscribe(banks => {
        this.banks = banks.banks;
      });
  }

  onFilesAdded(event) {
    this.uploadingfile = true;
    let files = event.target.files;
    this.loansService.doUpload(files[0])
      .subscribe(result => {
        this.uploadingfile = false;
        if (result.status == true) {
          this.photoHasBeenUploaded = true;
          this.filesUploaded.push(result.result);
        }

      });
  }
  openUploadDialog() {
    this.file.nativeElement.click();
  }
  uploadFile(event) {
  }
  clearRecords(){
    this.result = [];
    this.filesUploaded = [];
    this.photoHasBeenUploaded=false;
  }
  // getDueLoans(){
  //   this.loading = true;
  //   this.operationsService.getDueLoanss(this.currentUser.token).subscribe(data => {
  //     this.loading = false;
  //     if (data.status) {
  //       this.due_loans = data.data;
  //     } else {
  //       alert('Data could not be exported.');
  //     }
  //   });
  // }
  downloadActiveLoans() {
    this.loading = true;
    this.operationsService.downLoadActiveLoans(this.currentUser.token, this.product_id).subscribe(data => {
      this.loading = false;
      if (data.status) {
        alert('Data Successfully exported. Download would start automatically.');
        window.open(data.message);
        return;
      } else {
        alert('Data could not be exported.');
      }
    });
  }
  uploadPayments(){
    this.loading = true;
    this.operationsService.uploadPayments(this.currentUser.token, this.result.result).subscribe(data => {
      this.loading = false;
      this.finalpay = true;
      this.showSuccess('Success');
    });
    // this.loading = true;
    // this.loading = false;  
    // this.finalpay = true;
    // this.showSuccess('Success');
    // this.operationsService.uploadPayments(
    //   this.currentUser.token,
    //   this.result.result
    // );
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  doRepayment(value,i){
console.log(value)
  }
}
